import { Container, Card, Button } from '../../components/ui';
import TarjetaOpcionHome from './TarjetaOpcionHome';
import './Home.css';

const IconBuscar = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
);
const IconAgenda = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
);
const IconMedico = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
);

const OPCIONES = [
  { to: '/buscar', icono: <IconBuscar />, titulo: 'Buscar y reservar', descripcion: 'Asistente guiado en 3 pasos para encontrar el turno ideal.' },
  { to: '/mis-turnos', icono: <IconAgenda />, titulo: 'Mis turnos', descripcion: 'Revisá tus próximos turnos y el historial de los últimos meses.' },
  { to: '/medico/agenda', icono: <IconMedico />, titulo: 'Soy médico', descripcion: 'Gestioná tu disponibilidad, tus servicios y tu agenda.' },
];

export default function Home() {
  return (
    <Container>
      <section className="home-hero">
        <h1>Reservá tu turno médico en pocos clics</h1>
        <p>Buscá profesionales por nombre o por servicio, consultá la disponibilidad según tu cobertura y gestioná tus turnos desde un solo lugar.</p>
        <div className="home-hero-actions">
          <Button to="/buscar" variant="secondary" size="lg">Buscar un turno</Button>
          <Button to="/mis-turnos" variant="ghost" size="lg" style={{ color: '#fff' }}>Ver mis turnos →</Button>
        </div>
      </section>

      <h2 style={{ marginTop: 'var(--space-6)' }}>¿Qué querés hacer?</h2>
      <div className="home-cards">
        {OPCIONES.map((o) => <TarjetaOpcionHome key={o.to} {...o} />)}
      </div>

      <Card className="home-info">
        <div className="home-info-row">
          <div>
            <h3 style={{ marginTop: 0, marginBottom: 4 }}>¿Cómo funciona la cobertura?</h3>
            <p className="home-muted" style={{ margin: 0 }}>
              Según tu plan de obra social, cada prestación puede estar cubierta total, parcialmente o no cubierta. El costo final del turno se calcula al reservar.
            </p>
          </div>
          <Button to="/buscar" variant="secondary">Empezar</Button>
        </div>
      </Card>
    </Container>
  );
}